import { Box, styled } from '@mui/material';

const StyledModalBox = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  maxWidth: '95vw',
  maxHeight: '95vh',
  overflow: 'auto',
  backgroundColor: '#f0f2f5',
  borderRadius: theme.spacing(2),
  padding: theme.spacing(1),
  boxShadow: theme.shadows[24],
  outline: 'none',
  '&:focus': {
    outline: 'none',
  },
  '&:focus-visible': {
    outline: 'none',
  },
  '&:focus-within': {
    outline: 'none',
  },
}));

const BentoGrid = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr 1fr',
  gap: '12px',
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: '1fr',
    gridTemplateRows: 'auto',
  },
}));

const CloseButtonContainer = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(1),
  right: theme.spacing(1),
  zIndex: 1,
}));

export { StyledModalBox, BentoGrid, CloseButtonContainer };

